<template>
  <div>
    <div v-if="user.id">
      <comment-box ref="commentBox" @submit="postComment" />

      <promised
        :promise="commentsPromise"
        v-slot:combined="{ isPending, data }"
      >
        <skeleton-loading class="tw-mt-6" v-if="isPending" />
        <template v-else>
          <template v-if="data.data.length">
            <div
              class="tw-mt-10"
              v-for="comment in data.data"
              :key="comment.id"
            >
              <comment-content
                :value="comment"
                @report="onCommentReported"
                @delete="onCommentDeleted"
              />
            </div>

            <b-pagination
              class="tw-mt-8"
              v-if="data.meta.last_page > 1"
              @change="getComments"
              :total="data.meta.total"
              :current.sync="data.meta.current_page"
              :per-page="data.meta.per_page"
              order="is-centered"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
            >
            </b-pagination>
          </template>
          <div v-else class="tw-block tw-mt-6 tw-text-center tw-text-gray-300">
            No comments added
          </div>
        </template>
      </promised>
    </div>
    <div v-else>
      <router-link :to="{ name: 'login' }" class="button is-primary">
        Login to comment
      </router-link>
    </div>
    <report-modal ref="reportComment" :item="reportedComment" />
  </div>
</template>

<script>
import ReportModal from '@/components/modals/Report'
import CommentBox from './CommentBox'
import CommentContent from './CommentContent'
import Comment from '@/models/Comment'
import { map } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    CommentBox,
    CommentContent,
    ReportModal
  },
  props: {
    model: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: null
    },
    refresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commentsPromise: null,
      reportedComment: null
    }
  },
  mounted() {
    this.getComments()
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  watch: {
    refresh(n) {
      n ? this.getComments() : ``
    }
  },
  methods: {
    getComments(page = 1) {
      if (this.model) {
        this.commentsPromise = this.model
          .comments()
          .include('user', 'liked')
          .page(parseInt(page))
          .get()
      } else {
        this.commentsPromise = this.$api
          .get(
            `${this.type}/${this.id}/comments?include=user,liked&page=${page}`
          )
          .then(({ data }) => {
            data.data = map(data.data, comment => {
              return new Comment(comment)
            })
            return data
          })
      }
    },

    postComment(comment) {
      if (this.model) {
        const newComment = new Comment(comment).for(this.model)
        newComment.save().then(response => {
          this.$refs.commentBox.setSubmitting(false)
          this.getComments()
        })
      } else {
        this.commentsPromise = this.$api
          .post(`${this.type}/${this.id}/comments`, comment)
          .then(() => {
            this.$refs.commentBox.setSubmitting(false)
            this.getComments()
          })
      }
    },

    onCommentReported(comment) {
      this.reportedComment = comment
      this.$refs.reportComment.open()
    },

    onCommentDeleted(comment) {
      this.$api.delete(`/comments/${comment.id}`).then(() => {
        this.$buefy.snackbar.open({
          message: 'Successfully deleted your comment.',
          type: 'is-success',
          position: 'is-top'
        })
        this.getComments()
      })
    }
  }
}
</script>
